export default "__VITE_ASSET__4aacfcc0__"